export const pages = [
  {
    title: 'Família é Tudo',
    hashtag: 'FamíliaÉTudo',
    url: '/familia-e-tudo',
    header: 'GALERIA #FamíliaÉTudo',
    description:
      'Compartilhe uma foto da sua família para demonstrar o seu amor por ela ❤',
    shareMessage: '{0} no %FamíliaÉTudo %23RPC',
    shareMessageTwitter: '{0} no Família é Tudo!',
    palette: {
      dark: '#0a4d5e',
      main: '#009cbc',
      light: '#73b99b',
    },
    idCategoriaEnvio: 10,
  },

  {
    title: 'Amor de Mãe',
    hashtag: 'AmorDeMãe',
    url: '/amor-de-mae',
    header: 'GALERIA #AmorDeMãe',
    description:
      'Recebemos mais de 80 mil fotos das mamães paranaenses. Obrigado por dividir esses momentos com a gente! ❤',
    shareMessage: '{0} no %23AmorDeMãe %23RPC',
    shareMessageTwitter: '{0} no Amor de Mãe!',
    palette: {
      dark: '#D96E69',
      main: '#F89590',
      light: '#FFBDB9',
    },
    idCategoriaEnvio: 10,
  },

  {
    title: 'Em Casa Sim Sozinho Nunca',
    hashtag: 'EmCasaSimSozinhoNunca',
    url: '/em-casa-sim-sozinho-nunca',
    header: 'GALERIA #EmCasaSimSozinhoNunca',
    description:
      'Nesse momento ficar em casa é um ato de amor e adoramos ter você junto com a gente nessa campanha.',
    shareMessage:
      'Coisas incríveis acontecem quando nos unimos, {0}! %23EmCasaSimSozinhoNunca %23RPC',
    shareMessageTwitter: 'Coisas incríveis acontecem quando nos unimos, {0}!',
    palette: {
      dark: '#002a4a',
      main: '#003359',
      light: '#b0ddff',
    },
    idCategoriaEnvio: 12,
  },

  {
    title: 'Mães Paranaenses',
    hashtag: 'MãesParanaenses',
    url: '/dia-das-maes',
    header: 'GALERIA #MãesParanaenses',
    description: 'Obrigado por dividir esse momento especial com a gente!',
    shareMessage:
      'Venha com {0} no dia das mães da RPC! %23MãesParanaenses %23RPC',
    shareMessageTwitter: 'Venha com {0} no dia das mães da RPC!',
    palette: {
      dark: '#1c6b80',
      main: '#2b9ebb',
      light: '#a1ecff',
    },
    idCategoriaEnvio: 10,
  },

  {
    title: 'Nosso Amor na RPC',
    hashtag: 'NossoAmorNaRPC',
    url: '/dia-dos-namorados',
    header: 'GALERIA #NossoAmorNaRPC',
    description:
      'Não há distâncias para o amor. Obrigada por compartilhar o seu com a gente ❤️ Feliz dia dos namorados!',
    shareMessage:
      'Quem ama sempre dá um jeitinho de ficar mais perto, {0}! %23NossoAmorNaRPC %23RPC',
    shareMessageTwitter:
      'Quem ama sempre dá um jeitinho de ficar mais perto, {0}!',
    palette: {
      dark: '#ce5b7f',
      main: '#ce5b7f',
      light: '#d9b2be',
    },
    idCategoriaEnvio: 14,
  },
  {
    title: 'Vamos Superar Juntos',
    hashtag: 'VamosSuperarJuntos',
    url: '/vamos-superar-juntos',
    header: 'GALERIA #VamosSuperarJuntos',
    description:
      'Estamos vivendo um momento complicado e não sabemos ao certo como será daqui pra frente. Mas, de uma coisa temos certeza: nós vamos superar juntos!',
    shareMessage:
      'Coisas incríveis acontecem quando nos unimos, {0}! %23VamosSuperarJuntos %23RPC',
    shareMessageTwitter: 'Coisas incríveis acontecem quando nos unimos, {0}!',
    palette: {
      dark: '#002a4a',
      main: '#003359',
      light: '#b0ddff',
    },
    idCategoriaEnvio: 12,
  },
  {
    title: 'Amor de Pai',
    hashtag: 'AmorDePai',
    url: '/amor-de-pai',
    header: 'GALERIA #AmorDePai',
    description:
      'Cada #AmorDePai é único e estamos adorando conhecer cada um de vocês. Obrigado por dividir esse momento especial 💙',
    shareMessage:
      'Quem ama sempre dá um jeitinho de ficar mais perto, {0}! %AmorDePai %DiaDosPaisRPC',
    shareMessageTwitter: 'Venha com {0} no dia dos pais da RPC!',
    palette: {
      dark: '#e58700',
      main: '#e58700',
      light: '#f0c375',
    },
    idCategoriaEnvio: 16,
  },
  {
    title: 'Frio de lascar',
    hashtag: 'FrioDeLascar',
    url: '/frio-de-lascar',
    header: 'GALERIA #FrioDeLascar',
    description:
      'Chegou um #FrioDeLascar aqui no Paraná! Os termômetros paranaenses despencaram com uma friaca daquelas 🥶 Veja as fotos em todo o estado:',
    shareMessage: 'O frio de lascar já chegou aqui em casa',
    shareMessageTwitter: 'Venha com {0} nesse frio de lascar!',
    palette: {
      dark: '#06488d',
      main: '#06488d',
      light: '#6ea3db',
    },
    idCategoriaEnvio: 18,
  },
  {
    title: 'Amor por PG',
    hashtag: 'AmorPorPG',
    url: '/amor-por-pg',
    header: 'GALERIA #AmorPorPG',
    description:
      'Obrigado por compartilhar o lugar que você mais ama da nossa linda Ponta Grossa.',
    shareMessage: 'Meu Amor por PG',
    shareMessageTwitter: '{0} compartilhou o amor por PG',
    palette: {
      dark: '#47a3a9',
      main: '#47a3a9',
      light: '#6ea3db',
    },
    idCategoriaEnvio: 19,
  },
  {
    title: 'É tempo de flor',
    hashtag: 'ÉTempoDeFlor',
    url: '/primavera-rpc',
    header: 'GALERIA #ÉTempoDeFlor',
    description:
      'A Primavera chegou com muitas flores e cores em todo o Paraná.',
    shareMessage: 'É tempo de flor no Paraná',
    shareMessageTwitter: '{0},  É tempo de flor no Paraná',
    palette: {
      dark: '#e6959b',
      main: '#f5ced1',
      light: '#fce1e3',
    },
    idCategoriaEnvio: 20,
  },
  {
    title: 'Dia Do Professor na RPC',
    hashtag: 'DiaDoProfessor',
    url: '/dia-do-professor',
    header: 'Galeria #DiaDoProfessor',
    description:
      'Professor, a RPC valoriza e reconhece o seu trabalho! Envie sua foto no home office e participe com a gente!',
    shareMessage: 'Dia Do Professor na RPC',
    shareMessageTwitter: 'Dia Do Professor na RPC',
    palette: {
      dark: '#006497',
      main: '#006497',
      light: '#50bbf2',
    },
    idCategoriaEnvio: 21,
  },
  {
    title: 'Amor por Cascavel',
    hashtag: 'AmorPorCascavel',
    url: '/amor-por-cascavel',
    header: 'GALERIA #AmorPorCascavel',
    description:
      'Obrigado por compartilhar o lugar que você mais ama da nossa linda Cascavel.',
    shareMessage: 'Amor por Cascavel RPC',
    shareMessageTwitter: 'Amor por Cascavel RPC',
    palette: {
      dark: '#47a3a9',
      main: '#47a3a9',
      light: '#90eff5',
    },
    idCategoriaEnvio: 23,
  },
  {
    title: 'Natal RPC 2023',
    hashtag: 'NatalRPC2023',
    url: '/natal-rpc-2023',
    header: 'Galeria de Natal RPC 🎄',
    description:
      'Encontre a sua foto enviada pelo aplicativo Você na RPC e faça o Natal acontecer com a gente!',
    shareMessage: 'Natal RPC 2023',
    shareMessageTwitter: 'Natal RPC 2023',
    palette: {
      dark: '#cf3654',
      main: '#cf3654',
      light: '#cf3654',
    },
    idCategoriaEnvio: 57,
  },
  {
    title: 'Amor por Guarapuava',
    hashtag: 'AmorPorGuarapuava ',
    url: '/amor-por-guarapuava',
    header: 'GALERIA #AmorPorGuarapuava',
    description:
      'Obrigado por compartilhar o lugar que você mais ama da nossa linda Guarapuava.',
    shareMessage: ' Amor por Guarapuava RPC',
    shareMessageTwitter: ' Amor por Guarapuava RPC',
    palette: {
      dark: '#6dafb7',
      main: '#6dafb7',
      light: '#ade9ed',
    },
    idCategoriaEnvio: 25,
  },
  {
    title: 'Amor por Londrina',
    hashtag: 'AmorPorLondrina ',
    url: '/amor-por-londrina',
    header: 'GALERIA #AmorPorLondrina',
    description:
      'Obrigado por compartilhar o lugar que você mais ama da nossa linda Londrina.',
    shareMessage: ' Amor por Londrina RPC',
    shareMessageTwitter: ' Amor por Londrina RPC',
    palette: {
      dark: '#6dafb7',
      main: '#6dafb7',
      light: '#ade9ed',
    },
    idCategoriaEnvio: 26,
  },
  {
    title: 'Amor por Paranavaí',
    hashtag: 'AmorPorParanavaí ',
    url: '/amor-por-paranavai',
    header: 'GALERIA #AmorParanavaí',
    description:
      'Obrigado por compartilhar o lugar que você mais ama da nossa linda Paranavaí.',
    shareMessage: ' Amor por Paranavaí RPC',
    shareMessageTwitter: ' Amor por Paranavaí RPC',
    palette: {
      dark: '#6dafb7',
      main: '#6dafb7',
      light: '#ade9ed',
    },
    idCategoriaEnvio: 27,
  },
  {
    title: 'Amor de Mãe',
    hashtag: 'AMORDEMÃE',
    url: '/amordemae',
    header: 'GALERIA #AMORDEMÃE',
    description:
      'Encontre a sua foto enviada pelo aplicativo Você na RPC e compartilhe esse amor ❤',
    shareMessage: '{0} no %23AmorDeMãe %23RPC',
    shareMessageTwitter: '{0} no Amor de Mãe!',
    palette: {
      dark: '#000000',
      main: '#000000',
      light: '#2e2e2e',
    },
    idCategoriaEnvio: 30,
  },
  {
    title: 'Dia do Amigo 2021',
    hashtag: 'DiadoAmigoRPC',
    url: '/dia-do-amigo-2021',
    header: 'GALERIA #DiadoAmigoRPC',
    description:
      'Encontre a sua foto enviada pelo aplicativo Você na RPC e compartilhe essa amizade',
    shareMessage: '{0} no %23DiadoAmigoRPC %23RPC',
    shareMessageTwitter: '{0} no Dia do Amigo!',
    palette: {
      dark: '#000000',
      main: '#000000',
      light: '#2e2e2e',
    },
    idCategoriaEnvio: 38,
  },
  {
    title: 'Marcha para Jesus',
    hashtag: 'MarchaParaJesus',
    url: '/marcha-para-jesus',
    header: 'GALERIA #MarchaParaJesus',
    description:
      'Encontre a sua foto enviada pelo aplicativo Você na RPC e compartilhe esse momento',
    shareMessage: '{0} na %23MarchaParaJesus %23RPC',
    shareMessageTwitter: '{0} na Marcha Para Jesus!',
    palette: {
      dark: '#08183b',
      main: '#1a3155',
      light: '#495d7d',
    },
    idCategoriaEnvio: 51,
  },
]
